import { supabase, isSupabaseConfigured } from '../lib/supabaseClient';

/**
 * Supabase Auth işlemleri - yalnızca Anon Key ile çalışır.
 */

export const isUsingSupabaseAuth = isSupabaseConfigured;

export async function signInWithEmail(email, password) {
    if (!supabase) {
        throw new Error('Supabase yapılandırılmamış.');
    }

    const { data, error } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password
    });

    if (error) {
        if (/failed to fetch|network/i.test(error.message || '')) {
            return {
                error: 'Sunucuya bağlanılamadı. Supabase URL ve ağ bağlantınızı kontrol edin.'
            };
        }
        if (error.message?.includes('Email not confirmed')) {
            return { error: 'E-posta adresiniz henüz onaylanmamış. Supabase panelinden kullanıcıyı onaylayın.' };
        }
        if (error.message?.includes('Invalid login credentials')) {
            return { error: 'E-posta veya şifre hatalı.' };
        }
        return { error: error.message || 'Giriş başarısız.' };
    }

    const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('role, full_name')
        .eq('id', data.user.id)
        .single();

    if (profileError) {
        await supabase.auth.signOut();
        console.error('Profil okuma hatası:', profileError);
        return {
            error: profileError.message?.includes('recursion')
                ? 'Veritabanı güvenlik ayarı hatası. Lütfen 002_fix_profiles_rls.sql dosyasını Supabase\'de çalıştırın.'
                : 'Kullanıcı profili bulunamadı veya okunamadı. Supabase\'de profiles tablosunu kontrol edin.'
        };
    }

    if (profile?.role !== 'admin') {
        await supabase.auth.signOut();
        return { error: 'Bu hesabın admin yetkisi yok. Supabase\'de profiles.role = admin olmalı.' };
    }

    return {
        user: {
            id: data.user.id,
            email: data.user.email,
            role: profile.role,
            name: profile.full_name || data.user.email
        },
        token: data.session.access_token
    };
}

export async function signOutFromSupabase() {
    if (supabase) {
        await supabase.auth.signOut();
    }
}

export async function getSupabaseSessionUser() {
    if (!supabase) {
        return null;
    }

    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
        return null;
    }

    const { data: profile } = await supabase
        .from('profiles')
        .select('role, full_name')
        .eq('id', session.user.id)
        .single();

    if (profile?.role !== 'admin') {
        return null;
    }

    return {
        id: session.user.id,
        email: session.user.email,
        role: profile.role,
        name: profile.full_name || session.user.email,
        token: session.access_token
    };
}

export function onAuthStateChange(callback) {
    if (!supabase) {
        return { data: { subscription: { unsubscribe: () => {} } } };
    }

    return supabase.auth.onAuthStateChange((_event, session) => {
        callback(session);
    });
}
